<template>
  <div id="app">
    <background-video
      :videos="backgroundVideos"
      :active-section="activeSection"
      class="background-video" />
    <popup-section
      :popups="popups"
      :show-popup="showPopup"
      :active-section="activeSection"
      class="popup-section"
      @popup-hidden="hidePopup" />
    <intro-section
      :content="introContent"
    />
    <container
      v-for="(section, key) in sections"
      :ref="section.name"
      :key="key"
      class="container">
      <component
        v-in-viewport="-50"
        :name="section.name"
        :is="section.section"
        :content="section.content"
        @section-change="onSectionChange" />
    </container>
    <footer-section
      v-in-viewport="-50" />
  </div>
</template>

<script>
import BackgroundVideo from 'components/BackgroundVideo';
import IntroSection from 'components/IntroSection';
import PopupSection from 'components/PopupSection';
import Container from 'components/Container';
import DefaultSection from 'components/DefaultSection';
import FooterSection from 'components/FooterSection';
import appData from '@/data.json';
import inViewport from 'vue-in-viewport-directive';

export default {
  name: 'App',
  directives: {
    inViewport,
  },
  components: {
    BackgroundVideo,
    IntroSection,
    DefaultSection,
    PopupSection,
    Container,
    FooterSection,
  },
  data() {
    return {
      backgroundVideos: appData.backgroundvideos,
      sections: appData.sections,
      popups: appData.popups,
      introContent: appData.introContent,
      showPopup: false,
      popupsShown: [],
      activeSection: 'phase-1',
    };
  },
  watch: {
    activeSection() {
      if (this.popups.some(popup => popup.section === this.activeSection) && this.popupNotShown()) {
        this.showPopup = true;
        document.body.style.overflow = 'hidden';
        this.popupsShown.push(this.activeSection);
      }
    },
  },
  methods: {
    onSectionChange(name) {
      this.activeSection = name;
    },
    hidePopup() {
      this.showPopup = false;
      document.body.style.overflow = '';
    },
    popupNotShown() {
      for (let i = 0; i < this.popupsShown.length; i += 1) {
        if (this.popupsShown[i] === this.activeSection) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style lang="scss">
  * {
    box-sizing: border-box;
  }

  body,
  html {
    background-color: #EEE;
    font-family: $base-font;
    font-size: 1em;
    line-height: 1.5em;
    margin: 0;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue